{
  "print": {
    "story": {
      "title": "Fil rouge"
    }
  }
}